import { ReactNode } from 'react';
import { useParams } from 'react-router-dom';

import { ForbiddenView } from 'src/views/error';
import { useCourseAccess } from 'src/hooks/use-course-access';

type CourseAccessGuardProps = {
  children: ReactNode;
  fallback?: ReactNode;
};

export function CourseAccessGuard({ children, fallback }: CourseAccessGuardProps) {
  const { courseId } = useParams();
  const { canAccessCourse, isLoading } = useCourseAccess();

  if (isLoading) {
    return null;
  }

  if (!canAccessCourse(courseId)) {
    return fallback ? <>{fallback}</> : <ForbiddenView standalone={false} />;
  }

  return <>{children}</>;
}
